/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignedUrlResponse
 */
export interface SignedUrlResponse {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SignedUrlResponse
     */
    urls: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof SignedUrlResponse
     */
    existing?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof SignedUrlResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the SignedUrlResponse interface.
 */
export function instanceOfSignedUrlResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "urls" in value;

    return isInstance;
}

export function SignedUrlResponseFromJSON(json: any): SignedUrlResponse {
    return SignedUrlResponseFromJSONTyped(json, false);
}

export function SignedUrlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignedUrlResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'urls': json['urls'],
        'existing': !exists(json, 'existing') ? undefined : json['existing'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function SignedUrlResponseToJSON(value?: SignedUrlResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'urls': value.urls,
        'existing': value.existing,
        'error': value.error,
    };
}

